import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { environment } from 'src/environments/environment';

import { MatIconModule } from '@angular/material/icon';
import { HeaderService } from '../header/service/header.service';
import { CommonLoaderComponent } from '../shared/components/common-loader/common-loader.component';
import { ModulosBuscaService } from '../shared/components/filtros-busca/service/modulos-service/modulos.service';
import { LoaderMetricsComponent } from '../shared/components/loader-metrics/loader-metrics.component';
import { PageHeroComponent } from '../shared/components/page-hero/page-hero.component';
import { AuthService } from '../shared/services/auth/auth.service';
import { ErrorHandleService } from '../shared/services/error-handle/error-handle.service';
import { ObraNavegacaoService } from '../shared/services/obras-navegacao/obras-navegacao.service';
import { FiltroPeriodoComponent } from './components/filtros-metricas/filtro-periodo/filtro-periodo.component';
import { FiltroResponsavelComponent } from './components/filtros-metricas/filtro-responsavel/filtro-responsavel.component';
import { MapaComparativoComponent } from './components/mapa-comparativo/mapa-comparativo.component';
import { MotivosPerdaComponent } from './components/motivos-perda/motivos-perda.component';
import { ObrasPorFaseComponent } from './components/obras-por-fase/obras-por-fase.component';
import { ObrasPorTarefasComponent } from './components/obras-por-tarefas/obras-por-tarefas.component';
import { ObrasResponsaveisComponent } from './components/obras-responsaveis/obras-responsaveis.component';
import { VendasRegiaoComponent } from './components/vendas-regiao/vendas-regiao.component';
import { Responsavel } from './interface/metricas';
import { MetricasService } from './service/metricas.service';

@Component({
  selector: 'app-metricas',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MapaComparativoComponent,
    MotivosPerdaComponent,
    VendasRegiaoComponent,
    ObrasResponsaveisComponent,
    ObrasPorFaseComponent,
    FiltroResponsavelComponent,
    FiltroPeriodoComponent,
    ObrasPorTarefasComponent,
    CommonLoaderComponent,
    LoaderMetricsComponent,
    MatIconModule,
    PageHeroComponent,
  ],
  templateUrl: './metricas.component.html',
  styleUrls: ['./metricas.component.scss'],
})
export class MetricasComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  userID: string = '';

  responsable: Responsavel[] = [];
  intervaloSelecionado: Date[] | null = null;
  filtroResponsavel: string = 'Todos';
  atualizandoMetricas: boolean = false;
  private metricasRequestsAtivas = 0;

  downloadExportar: boolean = false;

  idObraSelecionada: number | null = null;
  obraIds: number[] = [];
  acessoMapaComparativo: boolean = false;

  level: string;
  '';
  userId: string;

  @Input() selectedUsuario: string = 'Todos';
  @Input() responsavel: any[] = [];

  @Output() obraSelecionada = new EventEmitter<number>();
  @Output() idsObras = new EventEmitter<number[]>();

  @ViewChild(ObrasPorFaseComponent)
  obrasPorFaseComponent!: ObrasPorFaseComponent;

  @ViewChild(MotivosPerdaComponent)
  motivosPerdaComponent!: MotivosPerdaComponent;

  @ViewChild(ObrasPorTarefasComponent)
  obrasPorTarefasComponent!: ObrasPorTarefasComponent;

  @ViewChild(ObrasResponsaveisComponent)
  obrasResponsaveisComponent!: ObrasResponsaveisComponent;

  @ViewChild(VendasRegiaoComponent)
  vendasRegiaoComponent!: VendasRegiaoComponent;

  @ViewChild(MapaComparativoComponent)
  mapaComparativoComponent!: MapaComparativoComponent;

  config: Partial<BsDaterangepickerConfig> = {
    containerClass: 'bs-datepicker',
    rangeInputFormat: 'DD/MM/YYYY',
    showWeekNumbers: false,
    selectFromOtherMonth: true,
    isAnimated: true,
    displayMonths: 1,
  };

  constructor(
    private readonly _metricasService: MetricasService,
    private readonly cdr: ChangeDetectorRef,
    private readonly _headerService: HeaderService,
    private readonly _errorHandleService: ErrorHandleService,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly obraNavegacaoService: ObraNavegacaoService,
    private readonly modulosBuscaService: ModulosBuscaService,
  ) {
    this.userID = this.authService.userID;
  }

  ngOnInit(): void {
    this.loadResponsables();
    this.getDadosUsuario();
  }

  loadResponsables(): void {
    this._metricasService.listResponsible().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
      },
    );
  }

  onResponsaveisRecebidos(resps) {
    if (!Array.isArray(resps)) {
      console.error('Responsáveis recebidos não são um array:', resps);
      return;
    }
    if (resps.length === 0) {
      console.warn('Array de responsáveis está vazio.');
    }

    if (resps.length > 0 && resps[0].id === undefined) {
      console.error('Responsável não possui propriedade id:', resps[0]);
    }
  }

  onPeriodoSelecionadoChange(
    periodo: { periodBegin: string; periodEnd: string } | null,
  ): void {
    if (periodo && periodo.periodBegin && periodo.periodEnd) {
      const toLocal = (s: string) => {
        const [y, m, d] = s.split('-').map(Number);
        return new Date(y, m - 1, d);
      };
      this.intervaloSelecionado = [
        toLocal(periodo.periodBegin),
        toLocal(periodo.periodEnd),
      ];
    } else {
      this.intervaloSelecionado = null;
    }
  }
  onResponsavelIdChange(responsavelId: number) {
    this.updateLoaderState(true);
    this.updateLoaderState(false);
  }

  onResponsavelLimpo(): void {
    this.updateLoaderState(true);
    this.updateLoaderState(false);
  }

  updateLoaderState(state: boolean): void {
    this.atualizandoMetricas = state;
    setTimeout(() => this.cdr.detectChanges());
  }

  onAtualizandoMetricasChange(value: boolean) {
    if (value) {
      this.metricasRequestsAtivas++;
    } else {
      this.metricasRequestsAtivas = Math.max(
        0,
        this.metricasRequestsAtivas - 1,
      );
    }
    this.atualizandoMetricas = this.metricasRequestsAtivas > 0;
    this.cdr.detectChanges();
  }

  onObraSelecionada({
    workId,
    obraIds,
    moduleId,
    workType,
    workTypesPorObra,
  }: {
    workId: number;
    obraIds: number[];
    moduleId?: number;
    workType?: string;
    workTypesPorObra?: Record<number, number>;
  }): void {
    if (!workId) return;

    const nomeModulo = this.getRotaModulo(moduleId, workType);
    if (!nomeModulo) {
      console.error('Módulo não encontrado para a obra:', {
        workId,
        moduleId,
        workType,
      });
      return;
    }

    const moduloPorObraId: Record<number, string> = {};
    if (workTypesPorObra) {
      for (const [id, tipoObraId] of Object.entries(workTypesPorObra)) {
        const modulo = this.getRotaModulo(tipoObraId);
        if (modulo) moduloPorObraId[Number(id)] = modulo;
      }
    }
    moduloPorObraId[workId] = nomeModulo;

    this.obraNavegacaoService.setObraIds(obraIds, nomeModulo, moduloPorObraId);
    this.router.navigate(['/buscas', nomeModulo, 'detalhes', workId]);
  }

  private getRotaModulo(moduleId?: number, workType?: string): string | null {
    const id = Number(moduleId ?? 0);
    if ([2, 3, 4, 234].includes(id)) return 'imobiliario';
    if (id) return this.modulosBuscaService.getRotaById(id);

    const normalizedType = String(workType ?? '')
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    const rotas: Record<string, string> = {
      imobiliario: 'imobiliario',
      industrial: 'industrial',
      edificacoes: 'edificacoes',
      infraestrutura: 'infraestrutura',
    };

    return rotas[normalizedType] ?? null;
  }

  onCompanyClick(empresa: {
    companyId?: number;
    companyName?: string;
    workType?: string;
  }): void {
    const empresaId = empresa.companyId;
    const nomeModulo = this.getRotaModulo(undefined, empresa.workType);

    if (empresaId && nomeModulo) {
      this.router.navigate(['/empresas/detalhes', nomeModulo, empresaId]);
      return;
    }

    const termo = empresa.companyName || '';
    if (!termo) {
      console.warn('Nome/dados da empresa não encontrados no evento:', empresa);
      return;
    }

    this.router.navigate(['/empresas'], { queryParams: { termo } });
  }

  capturarFiltrosGlobais(): any {
    const filtros: any = {};

    if (this.intervaloSelecionado && this.intervaloSelecionado.length === 2) {
      const formatDate = (date: Date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };
      filtros.period = {
        periodBegin: formatDate(this.intervaloSelecionado[0]),
        periodEnd: formatDate(this.intervaloSelecionado[1]),
      };
    }

    if (this.selectedUsuario !== 'Todos') {
      const responsibleId = Number(this.selectedUsuario) || 0;
      if (responsibleId !== 0) {
        filtros.responsible = {
          responsible: responsibleId,
        };
      }
    }

    return filtros;
  }

  async exportAllExcels() {
    this.downloadExportar = true;
    const filtrosGlobais = this.capturarFiltrosGlobais();

    const downloads = [];

    if (
      this.motivosPerdaComponent &&
      (this.motivosPerdaComponent.arrMotivos.length > 0 ||
        this.motivosPerdaComponent.tableData.length > 0)
    ) {
      downloads.push({
        obs: this._metricasService.downloadExcelLostReason(filtrosGlobais),
        filename: 'motivos-perda.xlsx',
      });
    }

    if (
      this.mapaComparativoComponent &&
      this.mapaComparativoComponent.comparativos.length > 0
    ) {
      downloads.push({
        obs: this._metricasService.downloadExcelComparativeMap(filtrosGlobais),
        filename: 'mapa-comparativo.xlsx',
      });
    }

    if (
      this.vendasRegiaoComponent &&
      (this.vendasRegiaoComponent.vendas.length > 0 ||
        this.vendasRegiaoComponent.tableData.length > 0)
    ) {
      downloads.push({
        obs: this._metricasService.downloadExcelWorkRegion(filtrosGlobais),
        filename: 'vendas-regiao.xlsx',
      });
    }

    if (
      this.obrasResponsaveisComponent &&
      (this.obrasResponsaveisComponent.arrObrasResponsavel.length > 0 ||
        this.obrasResponsaveisComponent.tableData.length > 0)
    ) {
      downloads.push({
        obs: this._metricasService.downloadExcelWorkResponsible(filtrosGlobais),
        filename: 'obras-responsaveis.xlsx',
      });
    }

    if (
      this.obrasPorFaseComponent &&
      (this.obrasPorFaseComponent.fasesDaObra.length > 0 ||
        this.obrasPorFaseComponent.tableData.length > 0)
    ) {
      downloads.push({
        obs: this._metricasService.downloadExcelWorkByMarketPhase(
          filtrosGlobais,
        ),
        filename: 'obras-por-fase.xlsx',
      });
    }

    if (
      this.obrasPorTarefasComponent &&
      (this.obrasPorTarefasComponent.arrObrasPorTarefa.length > 0 ||
        this.obrasPorTarefasComponent.tableData.length > 0)
    ) {
      downloads.push({
        obs: this._metricasService.downloadExcelWorkTask(filtrosGlobais),
        filename: 'obras-por-tarefas.xlsx',
      });
    }
    try {
      for (const { obs, filename } of downloads) {
        await new Promise<void>((resolve, reject) => {
          const timeout = setTimeout(
            () =>
              reject(
                new Error('Tempo limite excedido para download: ' + filename),
              ),
            15000,
          );
          obs
            .toPromise()
            .then((response) => {
              clearTimeout(timeout);
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              resolve();
            })
            .catch((err) => {
              clearTimeout(timeout);
              reject(err);
            });
        });
      }
    } finally {
      this.downloadExportar = false;
    }
  }

  async getDadosUsuario() {
    const companyId = this.authService.companyID;
    const restrictionKey = this.authService.restrictionKey;
    this.userId = this.authService.userID;

    await this._headerService
      .dadosUsuario(companyId, restrictionKey, this.userId)
      .subscribe(
        (response) => {
          if (response.success) {
            this.level = response.data.level;

            if (this.level === 'Restrito') {
              this.acessoMapaComparativo = false;
            } else {
              this.acessoMapaComparativo = true;
            }
            localStorage.setItem('level', response.data.level);
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        },
      );
  }
}
